<template>
  <div class="product-detail pt80">
    <div class="container1200">
      <Navbar />
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>{{ product.name || '' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div v-if="product">
        <div class="floating-cart" @click="goToCart">
          <el-button type="primary" size="large" circle>
            <i class="el-icon-shopping-cart-1" style="font-size: 24px;"></i>
          </el-button>
          <div class="cart-badge" v-if="cartCount > 0">{{ cartCount }}</div>
        </div>
        <!-- 商品信息 -->
        <el-row :gutter="40">
          <!-- 商品图片 -->
          <el-col :span="12">
            <div class="product-images">
              <div class="main-image">
                <img :src="arr[selectIndex] || ''" alt="Imagem Principal" class="main-img">
              </div>
              <div class="thumbnail-list">
                <img
                    v-for="(image, index) in arr"
                    :key="index"
                    :src="image || ''"
                    :class="['thumbnail', { active: selectIndex === index }]"
                    @click="selectIndex = index"
                >
              </div>
            </div>
          </el-col>

          <!-- 商品详情 -->
          <el-col :span="12">
            <div class="product-info">
              <h1 class="product-title">{{ product.name || '' }}</h1>
              <!-- <div class="product-subtitle">{{ product.subtitle }}</div> -->

              <div class="price-section">
                <span class="current-price">¥{{ price }} <span v-if="stock_num > 0">Inventario: {{ stock_num }}</span></span>
                <span class="original-price" v-if="product.originalPrice">¥{{ product.originalPrice }}</span>
                <span class="discount" v-if="product.discount">{{ product.discount }}折</span>
              </div>

              <div class="product-meta">
                <div class="meta-item">
                  <span class="label">SKU：</span>
                  <span class="value">{{ product.code }}</span>
                </div>
                <div class="meta-item">
                  <span class="label">Preço original：</span>
                  <span class="value">{{ product.sale_price }}</span>
                </div>
                <div class="meta-item" v-if="product && product.spec && product.spec.length">
                  <span class="label">COR：</span>
                  <div class="spec" v-for="(item,index) in product.spec" :key="item.spec_id" @click="specSelect(item,index)" :class="{'active': specIndex === index}">
                    {{ item.name || '' }}
                  </div>
                </div>

                <!-- <div class="meta-item">
                  <span class="label">销量：</span>
                  <span class="value">{{ product.sales }}件</span>
                </div>
                <div class="meta-item">
                  <span class="label">库存：</span>
                  <span class="value">{{ product.stock }}件</span>
                </div> -->
              </div>

              <!-- 规格选择 -->


              <!-- 数量选择 -->
              <div class="quantity-section">
                <span class="quantity-label">Quantidade：</span>
                <el-input-number
                    v-model="quantity"
                    :min="1"
                    :max="product.stock"
                    size="medium"
                ></el-input-number>
              </div>

              <!-- 操作按钮 -->
              <div class="action-buttons">
                <el-button
                    type="main"
                    size="large"
                    @click="addToCart"
                    :disabled="product.stock === 0"
                >
                  <i class="el-icon-shopping-cart-2"></i>
                  Adicionar ao carrinho
                </el-button>
                <!-- <el-button
                    type="danger"
                    size="large"
                    @click="buyNow"
                    :disabled="product.stock === 0"
                >
                  Compre agora
                </el-button> -->
                <el-button
                    size="large"
                    @click="toggleFavorite"
                    :class="{ 'is-favorite': isFavorite }"
                >
                  <i :class="isFavorite ? 'el-icon-star-on' : 'el-icon-star-off'"></i>
                  {{ isFavorite ? 'Colecionado' : 'Coleção' }}
                </el-button>
              </div>
            </div>
          </el-col>
        </el-row>

        <!-- 商品详细信息 -->
        <div class="detail-tabs">
          <div class="detail-tabs-title">DESCRIÇÃO</div>
          <div class="detail-content" v-html="product.content"></div>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-else class="loading">
        <el-loading text="Carregando..."></el-loading>
      </div>
    </div>
    <Footer/>

  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import { getProductDetail,hasCollect, uncollectGoods, collectGoods } from '@/api/product'
import { addCart,getCartNum } from '@/api/cart'



export default {
  name: 'ProductDetailPage',
  components: {
    Navbar,
    Footer
  },
  data() {
    return {
      stock_num: 0,
      cartCount: 0,
      hasSpec: false,
      arr: [],
      price: '',
      specIndex: 0,
      selectIndex: 0,
      activeIndex: '',
      activeTab: 'detail',
      selectedCapacity: '15ml',
      quantity: 1,
      collect_id: '',
      isFavorite: false,
      product: {
        name: '',
      },
      goods_id: '',
      loading: true
    }
  },
  mounted() {
    this.goods_id = this.$route.params.id;
    this.loadProduct()
    //在登录的情况下 是否已经收藏
     if(this.$store.getters['user/isLoggedIn']){
      this.checkFavorite()
      this.getCartNumFun()
    }

  },
  methods: {
     getCartNumFun(){
        getCartNum().then(res=>{
          this.cartCount = res.data.num
        }).catch(err=>{
          console.log('err',err)
        })

      },
    checkFavorite(){
      hasCollect({id: this.goods_id}).then(res => {
        this.collect_id = res.data.collect;
        this.isFavorite = res.data.collect > 0 ? true : false
      }).catch(err=>{
        console.log('err',err)
      })
    },
    specSelect(item,index){
      this.specIndex = index
      this.selectIndex = 0
      this.price = item.price
      this.arr = item.arr;
      this.stock_num = item.stock_num;
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath)
    },
    loadProduct() {
      // 模拟从API加载商品数据
      const productId = this.$route.params.id
      getProductDetail({
        id: productId
      }).then(res => {
        this.loading = false;
        // console.log('getProductDetail',res)
        this.product = res.data
        this.hasSpec = false;
        if(res.data.spec && res.data.spec.length){
          this.hasSpec = true;
          this.arr = res.data.spec[0].arr;
          this.price = res.data.spec[0].price
          this.stock_num = res.data.spec[0].stock_num;

        }else{
          this.arr = res.data.arr
          this.price = res.data.price
        }
        this.selectIndex = 0
        this.specIndex = 0
      }).catch(err=>{
        console.log('err',err)
      })


    },
    goToCart() {
      this.$router.push('/cart')
    },
    addToCart() {
      // this.$message.success(`${this.product.name} 已加入购物车`)
      if (!this.$store.getters['user/isLoggedIn']) {
          // 触发 Navbar 的登录弹窗
          this.$root.$emit('showLoginDialog')
          this.$message.warning('Por favor, faça login antes de adicionar produtos ao carrinho')
          return
        }
        const {quantity,product,goods_id,hasSpec,specIndex,arr} = this;

        const data = {
          goods_id:  goods_id,
          name: product.name,
          num: quantity,
        };
        //加入规格
        if(hasSpec){
          data.spec_id = product.spec[specIndex].spec_id;
        }
        // 已登录，继续添加购物车逻辑
        addCart(data).then(res=>{
          this.$message.success('Adicionado ao carrinho')
          // 购物车按钮动画效果
          const cartButton = document.querySelector('.floating-cart .el-button')
          if (cartButton) {
            cartButton.classList.add('cart-bounce')
            setTimeout(() => {
              cartButton.classList.remove('cart-bounce')
            }, 600)
          }
          this.getCartNumFun()
        }).catch(err=>{
        console.log('err',err)
      })
    },
    buyNow() {
      if (!this.$store.getters['user/isLoggedIn']) {
          // 触发 Navbar 的登录弹窗
          this.$root.$emit('showLoginDialog')
          this.$message.warning('Faça login antes de adicionar produtos ao carrinho')
          return
        }
      // this.$message.success('跳转到结算页面')
      let query =  '?goods_id=' + this.goods_id + '&num=' + this.quantity
       //加入规格
        if(this.hasSpec){
          query += "&spec_id=" + this.product.spec[this.specIndex].spec_id
        }
      this.$router.push('/settle' + query )
    },
    toggleFavorite() {
      // this.isFavorite = !this.isFavorite
      if(this.isFavorite){
        uncollectGoods({id: this.collect_id}).then(res=>{
          this.$message.success('Adicionado aos favoritos')
          this.checkFavorite();
        }).catch(err=>{
        console.log('err',err)
      })
      }else{
        collectGoods({id: this.goods_id}).then(res=>{
          this.$message.success('Adicionado aos favoritos')
          this.checkFavorite();
        }).catch(err=>{
        console.log('err',err)
      })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  padding: 0;
  margin-bottom: 20px;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  height: 60px;
}

.logo h2 {
  margin: 0;
  color: #ff6b6b;
}

.nav-menu {
  border-bottom: none;
}

.auth-buttons {
  display: flex;
  gap: 10px;
}

.breadcrumb-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px 20px;
}

.main-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.product-images {
  text-align: center;
}

.main-image {
  margin-bottom: 20px;
}

.main-img {
  width: 100%;
  max-width: 400px;
  height: 400px;
  object-fit: cover;
  border-radius: 8px;
}

.thumbnail-list {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.thumbnail {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.3s;
}

.thumbnail.active {
  border-color: #ff6b6b;
}

.thumbnail:hover {
  border-color: #ff6b6b;
}

.product-info {
  padding-left: 20px;
}

.product-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
}

.product-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.price-section {
  margin-bottom: 20px;
}

.current-price {
  font-size: 32px;
  color: #ff6b6b;
  font-weight: bold;
}

.original-price {
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
  margin-left: 15px;
}

.discount {
  background-color: #ff6b6b;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-left: 15px;
}

.product-meta {
  margin-bottom: 30px;
  .meta-item {
    display: flex;
    margin-bottom: 8px;
    .label {
      width: 130px;
      color: #666;
    }
    .value {
      color: #333;
      font-weight: 500;

    }
    .spec{
      color: #333;
      background: #f5f5f5;
      padding: 0 5px;
      cursor: pointer;
      font-weight: 500;
      &.active{
        background: #e60013;
        color: #fff;
      }
    }
  }
}

.spec-section {
  margin-bottom: 30px;
}

.spec-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.spec-label {
  width: 80px;
  color: #666;
}

.quantity-section {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  .quantity-label {
    width: 130px;
    color: #666;
  }
}



.action-buttons {
  display: flex;
  gap: 15px;
}

.action-buttons .el-button {
  flex: 1;
  height: 50px;
}

.is-favorite {
  color: #ff6b6b;
}

.detail-tabs {
  margin-top: 60px;
  .detail-tabs-title{
    font-size: 18px;
    margin-bottom: 15px;
  }
}

::v-deep .detail-content {
  font-size: 14px;
  color: #666666;
  ::v-deep ul{
    margin: 0;
    padding: 0;
  }
  ::v-deep li{
    list-style: none;
  }
}


.specs-content {
  padding: 20px 0;
}

.reviews-content {
  padding: 20px 0;
}

.review-summary {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

.rating-overview {
  display: flex;
  align-items: center;
  gap: 15px;
}

.rating-score {
  font-size: 36px;
  font-weight: bold;
  color: #ff6b6b;
}

.review-count {
  color: #666;
}

.review-item {
  border-bottom: 1px solid #eee;
  padding: 20px 0;
}

.review-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 10px;
}

.reviewer-name {
  font-weight: bold;
  color: #333;
}

.review-date {
  color: #999;
  font-size: 14px;
}

.review-content {
  color: #666;
  line-height: 1.6;
}

.loading {
  text-align: center;
  padding: 100px 0;
}



/* 漂浮购物车按钮 */
.floating-cart {
  position: fixed;
  right: 30px;
  top: 50vh;
  z-index: 1000;
  cursor: pointer;
}

.floating-cart .el-button {
  width: 60px;
  height: 60px;
  background-color: #00c950;
  color: #fff;
  border-color: #00c950;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.floating-cart .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.cart-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: #ff4757;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  border: 2px solid white;
}

/* 购物车按钮弹跳动画 */
.cart-bounce {
  animation: cartBounce 0.6s ease-in-out;
}

@keyframes cartBounce {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(0.9);
  }
  75% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 购物车徽章出现动画 */
.cart-badge {
  animation: badgeAppear 0.3s ease-out;
}

@keyframes badgeAppear {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
